import { render, staticRenderFns } from "./equipment-fields-db.component.vue?vue&type=template&id=37f26a76"
import script from "./equipment-fields-db.component.ts?vue&type=script&lang=ts&external"
export * from "./equipment-fields-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f26a76')) {
      api.createRecord('37f26a76', component.options)
    } else {
      api.reload('37f26a76', component.options)
    }
    module.hot.accept("./equipment-fields-db.component.vue?vue&type=template&id=37f26a76", function () {
      api.rerender('37f26a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/fields-db/equipment-fields-db/equipment-fields-db.component.vue"
export default component.exports